import React, { useState, useEffect } from "react";
import axios from "axios";
import "animate.css";

const RandomImages = () => {
  const [galleryData, setGalleryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentItems, setCurrentItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("schoolGallery.php");
        setGalleryData(response.data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (galleryData.length > 0) {
      updateDisplay();
      const intervalId = setInterval(updateDisplay, 5000);
      return () => clearInterval(intervalId);
    }
  }, [galleryData]);

  const getRandomImages = (images, count) => {
    const shuffled = images.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  };

  const selectRandomItems = (data, count) => {
    const shuffled = data.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  };

  const updateDisplay = () => {
    if (galleryData.length > 0) {
      const selectedItems = selectRandomItems(galleryData, 3).map((item) => ({
        ...item,
        randomImages: getRandomImages(
          item.images,
          4 // Always display 4 images for consistent alignment
        ),
      }));
      setCurrentItems(selectedItems);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!galleryData || galleryData.length === 0) {
    return <div>No gallery data available.</div>;
  }

  return (
    <div className="container">
      {currentItems.map((item) => (
        <div key={item.id} className="row" style={{ marginBottom: "20px" }}>
          <div className="col-xs-12">
            <h2 className="text-center animate__animated animate__fadeInDown">
              {item.title}
            </h2>
          </div>
          <div className="col-xs-12">
            <div className="row">
              {item.randomImages.map((image, index) => (
                <div key={index} className="col-xs-12 col-sm-6 col-md-3">
                  <img
                    src={axios.defaults.baseURL + "/Images/" + image}
                    alt={item.title}
                    className="img-responsive animate__animated animate__fadeInUp"
                    style={{
                      width: "100%",
                      height: "28rem",
                      marginBottom: "10px",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RandomImages;
